/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Rails_Tools_CountInputs */

const en_directory_rails_tools_count = /** @type {(inputs: Directory_Rails_Tools_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tools`)
};

const zh_directory_rails_tools_count = /** @type {(inputs: Directory_Rails_Tools_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个工具`)
};

/**
* | output |
* | --- |
* | "{count} tools" |
*
* @param {Directory_Rails_Tools_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_tools_count = /** @type {((inputs: Directory_Rails_Tools_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Tools_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_tools_count(inputs)
	return zh_directory_rails_tools_count(inputs)
});
export { directory_rails_tools_count as "directory.rails.tools_count" }